module.exports = __webpack_public_path__ + "02f61f59222ae9e4629db6ef13d6ba95.pdf";